<template>
<div>
      <div id="uploaded">
         <div class="file-status">File Upload Status</div>
         <div v-if="isIngesting || isFetching" class="ingesting-message">
            Ingesting files into Bard database...
         </div>
         <div v-if="isSuccess" class="filelist-wrapper">
            <div class='filelist' v-bar>
               <div class="files-container">
                  <div class="file-row"
                     v-for="file in successFiles"
                     :key="file.recid">
                     <img v-if="file.thumbnail" class="file-thumb" :src="GALLERY_HOST + '/' + file.thumbnail">
                     <div class="file-text-container">
                        <div class="filename">{{file.filename}}</div>
                        <div class="file-size">{{file.file_size}}</div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
   // data() {
   //    return {
   //       uploadFieldName: '',
   //       uploadError: null,
         
   //       uploadTotal: 0,
   //       uploadProgress: 0,
   //       fileCount: 0
   //    }
   // },


   computed: {
      ...mapState('global', 
         [
          'successFiles'
         ]
      ),
     ...mapGetters('global', [
         'isInitial',
         'isUploading',
         'isIngesting',
         'isFetching', 
         'isSuccess', 
         'isFailed',   
      ]),

      // loadStyle() {
      //    return "width: " + this.uploadPercentageProgress + "%;";
      // }
   },


}
</script>

<style lang="scss" scoped>

.filelist-wrapper {
   // padding-right: 32px;
   &::-webkit-scrollbar {
      display: none;
   }
}

.filelist {
   // height: 218px;
   max-height: 218px;
   background-color: transparent;
   border: none;
   text-align: center;
   position: relative;
   color: white;
   padding-right: 50px;
   overflow-x: hidden;
   overflow-y: scroll;
   

   &::-webkit-scrollbar {
      display: none;
   }

   &.vb-invisible {
      .files-container {
         &::after {
            background-color: transparent;
         }
      }
   }

   

   input {
      position: absolute;
      width: 340px;
      height: 237px;
      left: 0;
      top: 0;
      opacity: 0;
   }
}

.drag-icon {
   width: 175px;
   height: 150px;
   position: relative;
   pointer-events: none;
}

.file-status {
   font-size: 16px;
   text-transform: uppercase;
   color: $gray-text;
   letter-spacing: 2px;
   margin-bottom: 25px;
}

.files-container {
   padding-bottom: 10px;
   max-height: 200px;
   width: 100% !important;
   &::after {
      content: '';
      width: 4px;
      height: 100%;
      position: absolute;
      right: .5em;
      top: 0;
      z-index: 1;
      background-color: #333e51;
   }
   &::-webkit-scrollbar {
      display: none;
   }
}

.uploaded-message {
   padding: 10px 0;
}

.file-row {
   position: relative;
   display: flex;
   border: 1px solid $bard-gray;
   margin-bottom: 15px;
   min-height: 67px;

   &:last-child {
      margin-bottom: 0px;
   }

   &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 4%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-image: url('../../assets/img/media/graphic-upload-success.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 20px 20px;
   }

   .file-row-load-indicator {
      height: 50px;
      background: rgba(128, 128, 128, .2);
      position: absolute;
      z-index: 0;
   }

   .file-thumb {
      // width: 65px;
      height: 65px;
   }

   .file-text-container {
      text-align: left;
      padding-left: 11px;
      padding-top: 12px;

      width: 322px;
      white-space: nowrap;
   }

   .filename {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   .file-size {
      font-size: 10px;
      color: $gray-text;
   }
}

.filestyle {
   text-decoration: underline;
   color: $bard-gray;
}
</style>